// @ngInject
function setFieldConfirmationDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message, level, fieldType, minValue, maxValue) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'setFieldConfirmationDialogController as vm',
            templateUrl: 'services/dialogs/setFieldConfirmationDialog/setFieldConfirmationDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            },
            level: function() {
                return level;
            },
            fieldType: function() {
                return fieldType;
            },
            minValue: function() {
                return minValue;
            },
            maxValue: function() {
                return maxValue;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function setFieldConfirmationDialogController($uibModalInstance, message, level, fieldType, minValue, maxValue, $sce) {
    var vm = this;

    vm.message = $sce.trustAsHtml(message);
    vm.level = level;
    vm.fieldType = fieldType;
    vm.dateValue = new Date();
    vm.numberValue = 0;
    if (fieldType === 'date') {
        vm.minValue = minValue ? minValue : '' + (new Date().getFullYear() - 5) + '-' + new Date().getMonth() + '-' + new Date().getDate() + ' 00:00:00';
        vm.maxValue = maxValue ? maxValue : '' + (new Date().getFullYear() + 5) + '-' + new Date().getMonth() + '-' + new Date().getDate() + ' 00:00:00';
    } else if (fieldType) {
        vm.minValue = minValue || minValue === 0 ? minValue : 0;
        vm.maxValue = maxValue || maxValue === 0 ? maxValue : 100;
    }

    vm.closeModal = closeModal;

    function closeModal(isCompleted) {
        $uibModalInstance.close({
            isCompleted: isCompleted,
            dateValue: dateToUtc(vm.dateValue),
            numberValue: vm.numberValue
        });
    }

    function dateToUtc(date) {
        var milliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
        var d = new Date(milliseconds);
        return d;
    }
}

angular
    .module('services.dialogs.setFieldConfirmationDialog', [])
    .service('setFieldConfirmationDialogService', setFieldConfirmationDialogService)
    .controller('setFieldConfirmationDialogController', setFieldConfirmationDialogController);
